'use client';

import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

type TooltipEngine = 'tippy' | 'floating-ui';

const TooltipEngineContext = createContext<TooltipEngine>('tippy');

type TooltipEngineProviderProps = {
    engine: TooltipEngine;
    children: ReactNode;
};

export const TooltipEngineProvider = ({ engine, children }: TooltipEngineProviderProps) => {
    return <TooltipEngineContext.Provider value={engine}>{children}</TooltipEngineContext.Provider>;
};

export const useTooltipEngine = () => useContext(TooltipEngineContext);
